import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Input from 'sushiweb/InputTypes/Input';
import { P } from 'sushiweb/Typography/Text';
import { InputWrapper } from '../styles';

const StyledInput = styled(Input)`
  width: 100%;
  margin: 1.6rem 0;
`;

const InputContainer = ({ parameter, label, value, large, disabled }) => {
  return (
    <InputWrapper large={large}>
      <P>{parameter}</P>
      <StyledInput
        value={value}
        innerWidth='100%'
        label={label}
        disabled={disabled}
      />
    </InputWrapper>
  );
};

InputContainer.propTypes = {
  parameter: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  large: PropTypes.bool,
  disabled: PropTypes.bool,
};

InputContainer.defaultProps = {
  parameter: '',
  label: '',
  value: '',
  large: false,
  disabled: false,
};

export default InputContainer;
